/**
 * @about folder view file that create and contains folders
 * create new folder
 * Project folder section
 * 
 */
// react lib
import React, { Component } from 'react';
// folder section
import FolderSection from "../add_folder_common/AddFolder";

class ProjectFolder extends Component { 
    render() {
        return (
            <FolderSection
                {...this.props}
                titleName = "PROJECTS"
                folderType = "1"
                link = "projects"
            />
         );
    }
}
export default ProjectFolder;
